import { useParams } from 'react-router';
import { VydejMenu } from '../../vydej/vydejmenu';
import { useSelector } from '../../hooks';

import { Error, ERROR_TYPE } from '../components/Error';
import { NewOrderSuccess } from '../../orders/components/NewOrderSuccess';
import AppWrapper from '../../AppWrapper';
import { APP_TYPE } from '../../constants';

const VydejNewOrderSuccessPage = () => {
  const { id } = useParams<{ id: string }>();
  const { apps } = useSelector((state) => state.app.config);

  return (
    <>
      {apps?.vydej ? (
        <AppWrapper appType={APP_TYPE.VYDEJ} menu={<VydejMenu />}>
          <NewOrderSuccess orderId={id!} />
        </AppWrapper>
      ) : (
        <Error type={ERROR_TYPE.NOT_FOUND} />
      )}
    </>
  );
};

export default VydejNewOrderSuccessPage;
